import { useNavigate } from "react-router-dom";
import { Nav } from "../components/site/Nav";
import { Footer } from "../components/site/Footer";
import { Hero } from "../components/site/Hero";
import { Marquee, SectionHead } from "../components/site/Motion";
import { ProcessScroll } from "../components/process/ProcessScroll";
import { ProcessFinale } from "../components/process/ProcessFinale";
import { CaseCard, ResultsDisclaimer } from "../components/site/CaseStudies";
import { Services } from "../components/site/Services";
import { PricingCards, PricingDisclosure } from "../components/site/Pricing";
import { FinalCTA } from "../components/site/FinalCTA";
import { useContent, usePageMeta } from "../lib/content";

export default function Home() {
  const { content } = useContent();
  const navigate = useNavigate();
  usePageMeta(
    "Rivanta Labs | Facebook & Instagram Advertising Agency in Billings, Montana",
    "Done-for-you Facebook & Instagram ads for service businesses. Billings, Montana Meta ads management, video ad production and lead generation for contractors."
  );
  const cases = Array.isArray(content?.case_studies) ? content.case_studies : [];

  return (
    <div className="relative">
      <Nav />
      <main>
        <Hero />
        <div className="border-y border-white/[0.06] bg-char py-6 sm:py-8">
          <Marquee className="font-serif text-3xl italic text-slate-200 sm:text-5xl"
            items={["We Script It.", "We Film It.", "We Edit It.", "We Run It.", "You Get the Leads."]} />
        </div>
        <ProcessScroll />
        <ProcessFinale />

        <section id="results" className="relative py-24 lg:py-36" data-testid="results-section">
          <div className="container-x">
            <SectionHead eyebrow="Client Results" title={["Real Businesses.", "Real Results."]}
              sub="A look at what we've accomplished with businesses we've worked with." />
            {cases.length > 0 && (
              <div className="mt-16 grid gap-6 lg:grid-cols-2 lg:items-start">
                {cases.map((cs, i) => <CaseCard key={cs.id || i} cs={cs} index={i} />)}
              </div>
            )}
            <ResultsDisclaimer text={content?.results_disclaimer} />
          </div>
        </section>

        <Services />

        <section id="pricing" className="relative border-t border-white/[0.06] bg-char py-24 lg:py-36" data-testid="pricing-section">
          <div className="container-x">
            <SectionHead eyebrow="Pricing" title="Choose How You Want to Grow."
              sub="Straightforward monthly packages designed for businesses at different stages of growth." />
            <div className="mt-16"><PricingCards packages={content?.packages} onSelect={() => navigate("/get-started#apply")} /></div>
            <PricingDisclosure text={content?.ad_spend_disclosure} />
          </div>
        </section>

        <FinalCTA />
      </main>
      <Footer />
    </div>
  );
}
